import React, { Component } from "react";
import MaterialTable from "material-table";
import { IconButton } from "@material-ui/core";
import Icon from "@jll/icon";
import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";
import Pagination from "../../../../Component/Pagination";
import { RecordIcon, ScoreIndicator, LongText } from "../../../../Component";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import { formatDate } from "../../../../Utilities/Functions";
import { Grid } from "@material-ui/core";
import CustomTableHeader from "../../../../Component/Table/CustomMTableHeader";
import CustomMTableRow from "../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../Component/Table/CustomMTableCell";
import { LightTooltip } from "../../../../Component";
import Typography from "@material-ui/core/Typography";
import RecordPreview from "../RecordPreview";
import { withTranslation } from "react-i18next";

const renderCanWorkWith = (canWork) => {
  if (canWork) {
    return (
      <span>
        Can Work
        <Icon
          className="far fa-check-circle"
          style={{ color: "green", fontSize: 16 }}
        />
      </span>
    );
  } else {
    return (
      <span>
        Can't Work
        <Icon
          className="far fa-times-circle"
          style={{ color: "red", fontSize: 16 }}
        />
      </span>
    );
  }
};

class ResultTable extends Component {
  state = {
    pageSize: 0,
  };

  render() {
    const {
      classes,
      data,
      recordActions,
      totalItemsCount,
      pageNumber,
      rowsPerPage,
      handlePageChange,
      viewInfo,
      handlePageSizeChange,
      t,
    } = this.props;

    return (
      <div className={classes.tableWrapper}>
        <MaterialTable
          style={tableStyle}
          icons={tableIcons}
          elevation="0"
          options={tableOptions}
          isLoading={false}
          data={data}
          localization={{
            header: {
              actions: t("labels.common.table.actions"),
            },
            body: {
              emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
            },
          }}
          columns={[
            {
              title: t("labels.record.search.table.headers.country"),
              field: "country",
              render: (rowData) => {
                return <span>{rowData.country}</span>;
              },
            },
            {
              title: t("labels.record.search.table.headers.city"),
              field: "city",
              render: (rowData) => {
                return <span>{rowData.city}</span>;
              },
            },
            {
              title: t("labels.record.search.table.headers.recordName"),
              field: "name",
              render: (rowData) => (
                <Grid container style={{ paddingRight: 25 }}>
                  <Grid item xs={10} sm={10} md={10}>
                    <LongText text={rowData.name} />
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    {viewInfo && (
                      <LightTooltip title={<RecordPreview data={rowData} />}>
                        <Typography component="span">
                          <Icon
                            style={{
                              paddingLeft: 15,
                              float: "right",
                            }}
                            className="fas fa-info-circle"
                          />
                        </Typography>
                      </LightTooltip>
                    )}
                  </Grid>
                </Grid>
              ),
            },
            {
              title: t("labels.record.search.table.headers.dunsNumber"),
              field: "dunsNumber",
              cellStyle: {
                textAlign: "left",
              },
            },
            {
              title: t("labels.record.search.table.headers.recordType"),
              field: "type",
              cellStyle: {
                textAlign: "left",
                paddingLeft: 25,
              },
              render: (rowData) => {
                return (
                  <RecordIcon entityCategory={rowData.entityCategory} t={t} />
                );
              },
            },
            {
              title: t("labels.record.search.table.headers.kycScore"),
              field: "kycScore",
              render: (rowData) => {
                return (
                  <div>
                    <ScoreIndicator
                      score={rowData.kycScore}
                      expired={rowData.kycExpired}
                    />
                  </div>
                );
              },
            },
            {
              title: t("labels.record.search.table.headers.kycValidity"),
              field: "kycValidTo",
              render: (rowData) => {
                return (
                  <span>
                    {rowData.kycValidTo === "-"
                      ? "-"
                      : formatDate(rowData.kycValidTo)}
                  </span>
                );
              },
            },
            {
              title: t("labels.record.search.table.headers.amlScore"),
              field: "amlScore",
              render: (rowData) => {
                return (
                  <div>
                    <ScoreIndicator
                      score={rowData.amlScore}
                      expired={rowData.amlExpired}
                    />
                  </div>
                );
              },
            },
            {
              title: t("labels.record.search.table.headers.amlValidity"),
              field: "amlValidTo",
              render: (rowData) => {
                return (
                  <span>
                    {rowData.amlValidTo === "-"
                      ? "-"
                      : formatDate(rowData.amlValidTo)}
                  </span>
                );
              },
            },
            {
              title: t("labels.record.search.table.headers.canWork"),
              field: "risk",
              render: (rowData) => {
                return (
                  <span style={{ paddingLeft: 15 }}>
                    {rowData.canWorkWith === true
                      ? renderCanWorkWith(true)
                      : rowData.canWorkWith === false
                      ? renderCanWorkWith(false)
                      : "-"}
                  </span>
                );
              },
            },
          ]}
          actions={recordActions}
          components={{
            Action: (props) => {
              return (
                <Tooltip title={props.action.tooltip} placement="bottom">
                  <IconButton
                    className={classes.actionIcons}
                    onClick={(event) => props.action.onClick(event, props.data)}
                  >
                    <Icon
                      className={props.action.icon}
                      style={{ fontSize: 16 }}
                    />
                  </IconButton>
                </Tooltip>
              );
            },
            Header: (props) => <CustomTableHeader {...props} />,
            Row: (props) => <CustomMTableRow {...props} />,
            Cell: (props) => <CustomMTableCell {...props} />,
          }}
        />
        <Pagination
          handleRowsPerPage={handlePageSizeChange}
          rowsPerPage={rowsPerPage}
          pageNumber={pageNumber}
          handlePagination={handlePageChange}
          totalItemsCount={totalItemsCount}
        ></Pagination>
      </div>
    );
  }
}

export default withTranslation()(
  withStyles(styles, { withTheme: true })(ResultTable),
);
